import {ClearAuth, SetAuthToken, SetSSOToken} from "../storage/AuthToken";
import {WorkforceClinicPortal} from "../AppState";
import {SetLoginPortals} from "../storage/LogInPortals";
import {SetUserId} from "../storage/UserId";
import {toast} from "react-toastify";
import {GetUrlLocation} from "../BaseUrl";

export type USER_LOGIN_TYPE = 'WORKFORCE_ONE_LOGIN';
export type SSO_USER_LOGIN_TYPE = 'SSO_WORKFORCE_ONE_LOGIN';
export type SSO_TOKEN_USER_LOGIN_TYPE = 'SSO_TOKEN_WORKFORCE_ONE_LOGIN';
export const USER_LOGIN = 'WORKFORCE_ONE_LOGIN';
export const SSO_USER_LOGIN = 'SSO_WORKFORCE_ONE_LOGIN';
export const SSO_TOKEN_USER_LOGIN = 'SSO_TOKEN_WORKFORCE_ONE_LOGIN';
export interface WorkforceOneLoginPayload{
    userName:string
    password: string
    requestedUri: string
    sourceIp: string
}
export interface SSOWorkforceOneLoginPayload{
  requestedUri: string
  sourceIp: string
  ssoToken: string
  data?: string
}
export interface SSOTokenWorkforceOneLoginPayload{
  requestedUri: string
  sourceIp: string
  ssoToken: string
  isSiteSearch: boolean
  isEmbeddedOrder: boolean
  action:string
}
const doNotTrustClientIps = "127.0.0.1";
export function loginToWorkforce(userName: string, password: string): WorkforceOneLoginAction{
    return {
        type: USER_LOGIN,
        payload: {
            userName,
            password,
            requestedUri: `${window.location.protocol}//${window.location.hostname}/clinicportal/#/workforce-login`,
            sourceIp: doNotTrustClientIps
        }
    }
}

export function ssoOrderRequest(ssoToken: string, data?: string): SSOWorkforceOneLoginAction{
  return {
      type: SSO_USER_LOGIN,
      payload: {
          requestedUri: `${window.location.protocol}//${window.location.hostname}/clinicportal/#/workforce-login`,
          sourceIp: doNotTrustClientIps,
          ssoToken: ssoToken,
          data: data
      }
  }
}
export function ssoTokenLoginToWorkforce(ssoToken: string, isSiteSearch: boolean, isEmbeddedOrder: boolean, action:string): SSOTokenWorkforceOneLoginAction{
  return {
      type: SSO_TOKEN_USER_LOGIN,
      payload: {
          requestedUri: `${window.location.protocol}//${window.location.hostname}/clinicportal/#/workforce-login`,
          sourceIp: doNotTrustClientIps,
          ssoToken: ssoToken,
          isSiteSearch: isSiteSearch,
          isEmbeddedOrder: isEmbeddedOrder,
          action:action
      }
  }
}
export interface WorkforceOneLoginAction{
    type: USER_LOGIN_TYPE
    payload: WorkforceOneLoginPayload
}
export interface SSOWorkforceOneLoginAction{
  type: SSO_USER_LOGIN_TYPE
  payload: SSOWorkforceOneLoginPayload
}
export interface SSOTokenWorkforceOneLoginAction{
  type: SSO_TOKEN_USER_LOGIN_TYPE
  payload: SSOTokenWorkforceOneLoginPayload
}
interface ClinicPortals {
    Clinic: WorkforceClinicPortal[]
}
export interface WorkforceOneLoggedInPayload{
    Portal: ClinicPortals
    AuthToken: string
    UserId: number | string
    UserName?:string
}
export type USER_LOGGED_IN_TYPE = 'WORKFORCE_ONE_LOGGED_IN';
export const USER_LOGGED_IN = 'WORKFORCE_ONE_LOGGED_IN';
export interface WorkforceOneLoggedInAction {
    type: USER_LOGGED_IN_TYPE
    payload: WorkforceOneLoggedInPayload
}
export function WorkforceOneUserHasLoggedIn(webToken: string, userId: number| string, ssoToken: string, loginDetail: WorkforceOneLoggedInPayload) : WorkforceOneLoggedInAction {
    SetAuthToken(webToken);
    SetSSOToken(ssoToken);
    SetUserId(userId);
    toast.success('Log In Completed')
    if(loginDetail && loginDetail.Portal && loginDetail.Portal.Clinic){
        SetLoginPortals(loginDetail.Portal.Clinic);
    }
    loginDetail.AuthToken = webToken;
    loginDetail.UserId = userId;
    return {
        type: USER_LOGGED_IN,
        payload: loginDetail
    }
}

export type USER_LOGGED_IN_FAILED_TYPE = 'WORKFORCE_ONE_LOGGED_IN_FAILED';
export const USER_LOGGED_IN_FAILED = 'WORKFORCE_ONE_LOGGED_IN_FAILED';
export interface WorkforceOneLoggedInFailedAction{
    type: USER_LOGGED_IN_FAILED_TYPE
}
export function WorkforceOneUserLoginFailed(message?: string): WorkforceOneLoggedInFailedAction {
  toast.error(message || 'Log In Failed')
  return {
      type: USER_LOGGED_IN_FAILED,
  }
}

export interface WorkforceOneLoggedInWrongUrlPayload{
  Portal: ClinicPortals
  Message?: string
}
export type USER_LOGGED_IN_WRONG_URL_TYPE = 'WORKFORCE_ONE_LOGGED_IN_WRONG_URL';
export const USER_LOGGED_IN_WRONG_URL = 'WORKFORCE_ONE_LOGGED_IN_WRONG_URL';
export interface WorkforceOneLoggedInWrongUrlAction{
    type: USER_LOGGED_IN_WRONG_URL_TYPE
    payload: WorkforceOneLoggedInWrongUrlPayload
}
export function WorkforceOneLoggedInWrongUrl(loginDetail: WorkforceOneLoggedInWrongUrlPayload): WorkforceOneLoggedInWrongUrlAction {
    return {
        type: USER_LOGGED_IN_WRONG_URL,
        payload: loginDetail
    }
}

export interface WorkforceOneUserLogOutPayload{
  skipRedirect: boolean
}
export type USER_LOGGED_OUT_TYPE = 'WORKFORCE_ONE_USER_LOGGED_OUT';
export const USER_LOGGED_OUT = 'WORKFORCE_ONE_USER_LOGGED_OUT';
export interface WorkforceOneLogOutAction{
    type: USER_LOGGED_OUT_TYPE,
    payload: WorkforceOneUserLogOutPayload
}
export function WorkforceOneUserLogOut(skipRedirect: boolean = false): WorkforceOneLogOutAction {
    ClearAuth();
    return {
        type: USER_LOGGED_OUT,
        payload: { skipRedirect }
    }
}

export interface WorkforceOnePasswordResetPayload{
    userName: string
    invitationLink: string
    isForgotPassword: boolean,
}
export type USER_P_RESET_TYPE = 'WORKFORCE_ONE_USER_P_RESET';
export const USER_P_RESET = 'WORKFORCE_ONE_USER_P_RESET';
export interface WorkforceOnePasswordResetAction{
    type: USER_P_RESET_TYPE
    payload: WorkforceOnePasswordResetPayload
}
export function WorkforceOneUserPasswordReset(userName: string, loggedIn: boolean): WorkforceOnePasswordResetAction {
    return {
        type: USER_P_RESET,
        payload:{
            userName,
            invitationLink: loggedIn ? GetUrlLocation() : '',
            isForgotPassword: !loggedIn
        }
    }
}

export type WorkforceOneLoginActions = |  WorkforceOneLoginAction | SSOWorkforceOneLoginAction | SSOTokenWorkforceOneLoginAction | WorkforceOneLoggedInAction | WorkforceOneLoggedInFailedAction | WorkforceOneLogOutAction | WorkforceOnePasswordResetAction | WorkforceOneLoggedInWrongUrlAction
